/**
 * Select overrides — CoordioDropdown (Site) look across every MUI Select in Cortex.
 *
 * Forms still on MUI get the same panel language as foundation `CoordioDropdown`:
 * solid surface, 8px radius, soft shadow, min width so labels do not truncate,
 * soft inset hover. Glassmorphism is dropped so Select and CoordioDropdown read as one family.
 */

import type { Theme } from '@mui/material/styles';

const select: Theme['components'] = {
  MuiSelect: {
    defaultProps: {
      MenuProps: {
        PaperProps: {
          sx: {
            minWidth: 280,
            maxWidth: 'min(96vw, 420px)',
            maxHeight: 'min(40vh, 280px)',
            overflow: 'auto',
            marginTop: '4px',
            padding: '4px',
            borderRadius: '8px',
            border: '1px solid var(--color-border-default)',
            backgroundColor: 'var(--color-bg-surface)',
            backgroundImage: 'none',
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
            boxShadow: 'var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.12))',
          },
        },
        MenuListProps: {
          sx: {
            padding: 0,
          },
        },
      },
    },
    styleOverrides: {
      select: {
        fontSize: '0.875rem',
      },
      icon: {
        color: 'var(--color-text-secondary)',
        transition: 'transform 200ms ease',
      },
    },
  },
};

export default select;
